export default "__VITE_ASSET__DcKjsE2j__"